if (typeof document !== 'undefined' && document?.URL?.includes('utm_source=pwa')) {
    sessionStorage.setItem('isPWA', '1');
}

// App device: WINDOWS | ANDROID | PWA | WEB
export const DEVICE = typeof document !== 'undefined' ? ((document.URL.includes('ms-appx-web:///')) ? 'WINDOWS' : (!document.URL.includes('http://') && !document.URL.includes('https://')) ? 'ANDROID' : sessionStorage.getItem('isPWA') ? 'PWA' : 'WEB') : 'SW';

// Localhost detection
export const IS_LOCALHOST = typeof window !== 'undefined' ? Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
) : false;

// Config
export const APP_NAME = 'reborn-front';
export const API_URL = process.env.API_URL || '';
export const UPLOAD_URL = process.env.UPLOAD_URL || '';
export const IMAGE_URL = process.env.IMAGE_URL || '';
export const REVISION = process.env.COMMIT_HASH || 'local';
export const CLOUDFLARE_TURNSTILE_SITE_KEY = process.env.CLOUDFLARE_TURNSTILE_SITE_KEY || '';
export const GOOGLE_MAP_KEY = process.env.GOOGLE_MAP_KEY || '';
export const PUBLIC_URL = process.env.PUBLIC_URL || '/';
export const PUBLIC_ROOT_URL = process.env.PUBLIC_ROOT_URL || '/';
export const PUBLIC_DOMAINS = (process.env.PUBLIC_DOMAINS || '').split(',').map(e => e.trim());
export const SENTRY_DSN = process.env.SENTRY_DSN || '';
export const WEB_PUSH_PUBLIC_KEY = process.env.WEB_PUSH_PUBLIC_KEY || '';

// Social links
export const AMAZON_PARTNER_TAG = 'briabra-21';
export const SOCIAL_INSTAGRAM = "https://www.instagram.com/BrickfilmsCommunity/";
export const SOCIAL_TIKTOK = "https://www.tiktok.com/@brickfilmscommunity";
export const SOCIAL_DISCORD = "https://discord.gg/mmU2sVAJUq";
export const SOCIAL_YOUTUBE = "https://www.youtube.com/@BrickfilmsCommunity"; 
export const SOCIAL_FACEBOOK = "https://www.facebook.com/BrickfilmsCommunity"; 
export const SOCIAL_TWITTER_FR = "https://twitter.com/BrickfilmsFr";
export const SOCIAL_TWITTER_EN = "https://twitter.com/BrickfilmsEn";
export const SOCIAL_LINKEDIN = "https://www.linkedin.com/company/brickfilms-community/";
export const SOCIAL_PAYPAL = "https://www.paypal.me/BRICKABRACK";
export const SOCIAL_AMAZON = `https://www.amazon.fr/?tag=${AMAZON_PARTNER_TAG}`;
export const SOCIAL_TIPEEE = "https://www.tipeee.com/brick-a-brack";

// Computes build tag
export const BUILD = `${DEVICE.toLowerCase()}-${REVISION.substring(0, 7)}`;

// Manual config values
export const REFRESH_ERROR_DELAY = 10;
export const REFRESH_GUEST_DELAY = 60;
export const REFRESH_USER_DELAY = 10;
export const REFRESH_HOMEPAGE_DELAY = 15;
export const MESSAGES_BY_PAGE = 10;
export const MESSAGES_BY_PAGE_THREADS = 15;
export const ITEMS_BY_PAGE = 24;
export const ITEMS_BY_PAGE_SMALL = 10;

export const FINGERPRINT_VERSION = 1;
export const FINGERPRINT_CIPHER = '55499cc7-9c6a-4999-a068-38a80e65b5e8';
export const FINGERPRINT_SIGNATURE = 'a9e48908-a3b0-4551-8051-455ffcd030b4';

// Languages
export const LANGUAGES = [{
    value: 'en',
    label: 'English',
    tLabel: t => t('English'),
}, {
    value: 'fr',
    label: 'Français',
    tLabel: t => t('Français'),
}, {
    value: 'de',
    label: 'Deutsh',
    tLabel: t => t('Deutsh'),
}];

// Allowed languages
export const ALLOWED_CONTENT_LANGUAGES = ['en', 'fr', /*'de', 'pl'*/]; // API should also handle it or it will cause issues
export const ALLOWED_INTERFACE_LANGUAGES = ['en', 'fr'];
export const DEFAULT_LANGUAGE = 'en';

// Local storage keys
export const LS_PREFIX = 'bfc_';
export const LS_LNG_INTERFACE = `${LS_PREFIX}currentInterfaceLanguage`;
export const LS_LNG_CONTENT = `${LS_PREFIX}currentContentLanguages`;
export const LS_USER_CACHE = `${LS_PREFIX}userCache`;
export const LS_BADGE_CACHE = `${LS_PREFIX}badgeCache`;
export const LS_APRIL_FOOL = `${LS_PREFIX}imnotfun`;
export const LS_DARK_MODE = `${LS_PREFIX}darkmode`;

// Public email
export const PUBLIC_EMAIL = 'brickabrackv3@gmail.com';
